/**
 * Created by Gustavo on 08/06/2016.
 */

import {Injectable}   from '@angular/core';
import {EventBean}     from '../beansts/Event';
import {CardBean} from "../beansts/card.bean";

@Injectable()
export class AppDataService {

//IMPORTANT GAME DATA that i have to collect for a good game
public instagramUser    = null; //this is my user with photo and name grabbed on login
public event: EventBean = null;//this is the world I am playing grabbed on gameevent
public muted=false;
public eventRecipes=[]
public stream='';
public streamClose=true;
public latLng;
public spaceToEdit;
public socialRoom;
public room;  //this is the room i am currently on. added on addToParty
public userEventSkills//this is my skill on the world
public userEventContainer;//this is my items on the world

public channel;
public npcTriggers;
public secondAction;
public action;
public triggers;
public secondTriggers;
public activeTrigger;
public activeSecondTrigger;

public mapSession;



public tabToEdit
public memoryItem
//////////////////////////////////////////////////////////
public activeWrits
public points;
public avatar;

public tiping=false;

public target;
    public dashboardEvent;
    public edit=false;
    public android=false;
    public containerWallet=false;
    public balance=0;
    public admin=false; //sou admin?
    public page = ''//my current page
    public token              : string       = null;
    public companyId          : string       = null;
    public company            : any  = null;
    public temporaryVideoLink;
    public talkTo =null;
    public email='';
    public liveLink='';
    public object=null;
    public selectedItem=null
    public activeItens={};//keep list of itens that are active for itens
    public images={}
    public npc;
    public localConference;
    public userLookup={}
    public jitsiOn=false;
    public isMobile=false;
    public gameUrl='';
    public webGl=false;
    public vr=false;
    public photo =false;
    public toggleCellPhone=false;
    public toTransferList=null
    public lazyLoadComplete:boolean=false;
    public events: EventBean[] = null;
    public thumbnails: string[] = [];
    public dayOfWeek: number=null;
    public hasCompany=false;
    public hasEvent=false;
    public gotoPayment=false;
    public indication=null;
    public partyMembers=[]
    public friendOnEvent=null;
    public tableOnView=null;
    public openTable=false;
    public openContact=false;
    public userTab=0;
    public profilePicture='https://liveplanet.app.br/assets/landingstyle/profile.png'
    public mediaSize
    public conference=true;
    public cellScreen='main';
    public card: CardBean = null
    public userOnEvent:any              = null;
    public redirectOnComplete : string       = null;
    public pageTop = 0;
    public pageWidth=100;
    public landing=true;
    public headerOn=false;
    public eventToGo;
    public param;
    public hasServer=false;
    public focusIframe=""; //used to roomItem
    public tutorial=false;
    public itemUse=null;

    public clicking=false;

    public comments=[]
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/services/app-data.service.ts